import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export const icon = (theme: Theme) => css`
  width: 100%;
  height: 100%;
  color: ${theme.palette.secondary.mainContrast};
`
